import React, { forwardRef } from 'react';
import { Box as MuiBox, type BoxProps as MuiBoxProps } from '@mui/material';
import { splitSystemProps, type SystemShorthandProps } from '../systemProps';

export type BoxProps = MuiBoxProps & SystemShorthandProps;

const Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ children, sx, ...props }, ref) => {
    const split = splitSystemProps(props, sx);
    return (
      <MuiBox ref={ref} {...split.rest} sx={split.sx}>
        {children}
      </MuiBox>
    );
  }
);

Box.displayName = 'Box';

export default Box; //todo endre navnet på box, her bruker vi samme som MUI
